import { useState } from "react";
import { Link } from "react-router-dom";

import "./Navbar.css";
import logo from "../../assets/trainosys300.png";

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  function handleMobileMenuToggle() {
    setIsMobileMenuOpen((currentValue) => !currentValue);
  }

  function handleMobileLinkClick() {
    setIsMobileMenuOpen(false);
  }

  return (
    <header className="navbar">
      <button
        type="button"
        className="hamburger-button"
        onClick={handleMobileMenuToggle}
        aria-label="Toggle menu"
        aria-expanded={isMobileMenuOpen}
      >
        <span />
        <span />
        <span />
      </button>

      <Link to="/" className="logo-container" onClick={handleMobileLinkClick}>
        <img src={logo} alt="Trainosys Logo" className="logo-image" />
      </Link>

      <nav className="nav-links">
        <Link to="/courses">Courses</Link>
        <Link to="/#why-trainosys">Why Trainosys</Link>
        <Link to="/about">About</Link>
        <Link to="/popular">Popular</Link>
        <Link to="/contact">Contact</Link>
        <Link className="nav-button" to="/request-proposal">
          Request Proposal
        </Link>
      </nav>

      <nav
        className={`mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""}`}
      >
        <Link to="/courses" onClick={handleMobileLinkClick}>
          Courses
        </Link>
        <Link to="/#why-trainosys" onClick={handleMobileLinkClick}>
          Why Trainosys
        </Link>
        <Link to="/#about" onClick={handleMobileLinkClick}>
          About
        </Link>
        <Link to="/#popular" onClick={handleMobileLinkClick}>
          Popular
        </Link>
        <Link to="/contact" onClick={handleMobileLinkClick}>Contact Us</Link>
        <Link
          className="nav-button"
          to="/request-proposal"
          onClick={handleMobileLinkClick}
        >
          Request Proposal
        </Link>
      </nav>
    </header>
  );
}

export default Navbar;
